export const fonts = {
  heading: { value: "Roboto, sans-serif" },
  body: { value: "Roboto, sans-serif" },
};
